import Icon from '@ant-design/icons';
import { Modal } from 'antd';
import classNames from 'classnames';
import { useMemo, useRef } from 'react';

import CloseSvg from '@/components/Icon/svgs/close.svg';
import useAppBridge from '@/hooks/useAppBridge';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';

import VoiceSettings, { type VoiceSettingsRef } from '../Voice';
import styles from './index.less';

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleConfirmCb?: () => void;
}

const VoiceSettingsModal = (props: IProps) => {
  const { open, handleClose, handleConfirmCb } = props;

  const [layoutSize] = useStorage('layoutSize');
  const inMobile = useMemo(() => layoutSize === LAYOUT_SIZE.SMALL, [layoutSize]);

  const voiceSettingsRef = useRef<VoiceSettingsRef>(null);

  const { SAFE_AREA_TOP } = useAppBridge();

  const handleModalClose = () => {
    voiceSettingsRef.current?.stopAllAudio();
    handleClose();
  };

  return (
    <Modal
      className={classNames(styles.modal, {
        [styles.inMobile]: inMobile
      })}
      closable={false}
      destroyOnClose
      footer={null}
      mask={false}
      onCancel={handleModalClose}
      open={open}
    >
      <div
        className="absolute w-full h-[60px] top-0 left-0 z-[1] px-4 flex items-center pointer-events-none"
        style={
          SAFE_AREA_TOP
            ? {
                top: `${SAFE_AREA_TOP}vw`
              }
            : undefined
        }
      >
        <div
          className={
            'w-9 h-9 bg-[rgba(254,253,255,0.6)] rounded-[18px] p-1 cursor-pointer hover:bg-[rgba(254,253,255,0.8)] transition-all flex items-center justify-center duration-200 pointer-events-auto'
          }
          onClick={handleModalClose}
        >
          <Icon className="text-[20px] text-primary-black" component={CloseSvg} rotate={180} />
        </div>
      </div>
      <VoiceSettings
        ref={voiceSettingsRef}
        className={inMobile ? '' : '!mt-[60px]'}
        handleConfirmCb={handleConfirmCb}
      />
    </Modal>
  );
};

export default VoiceSettingsModal;
